import { styled } from '@mui/material/styles'

type PanelScrollerProps = {
  active: boolean
  seen: boolean
  animated?: boolean
}

export const PanelScroller = styled('div', {
  name: 'PanelScroller',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) =>
    prop !== 'active' && prop !== 'seen' && prop !== 'animated',
})<PanelScrollerProps>(({ active, seen, animated }) => {
  const offset = active ? '0' : '100%'
  const modifier = seen ? '-' : ''
  const left = `${modifier}${offset}`

  return {
    left,
    width: '100%',
    height: '100%',
    position: 'absolute',
    transition: animated ? 'left linear 150ms' : undefined,
  }
})
